var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { styles } from './input.styles';
import { InputSlotBottom, InputSlotTop, InputSlotLeft, InputSlotRight, InputSlotCenter, InputSlotPanel } from './slots';
export var InputContainer = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, width = _a.width, height = _a.height, style = _a.style, props = __rest(_a, ["children", "className", "width", "height", "style"]);
    var container_clasess = classNames(styles.container, (_b = {},
        _b[styles.disabled] = props.disabled,
        _b[styles.errored] = props.errored,
        _b));
    return _jsxs(_Fragment, { children: [_jsx(InputSlotTop, __assign({}, props)), _jsxs("div", __assign({ className: container_clasess, style: __assign({ height: height, width: width }, style) }, { children: [_jsx(InputSlotLeft, __assign({}, props)), _jsx(InputSlotCenter, __assign({}, props, { children: children })), _jsx(InputSlotRight, __assign({}, props)), _jsx(InputSlotPanel, __assign({}, props))] })), _jsx(InputSlotBottom, __assign({}, props))] });
};
